import { LocationDTO } from '@sales-center/common'
import { BillTo } from '@user/store/entityLocations'

const baseTitle = 'New Opportunity for'

export function useGetOpportunityTitle(
  billTo: LocationDTO | BillTo | undefined,
): string {
  if (!billTo) {
    return ''
  }
  if (billTo.company) {
    return `${baseTitle} ${billTo.company}`
  } else {
    return `${baseTitle} ${billTo.firstName} ${billTo.lastName}`
  }
}
